/**
 * @generated SignedSource<<a995f9f5567e38f838b47b4ec0004731>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Sort = "ASC" | "DESC";
export type InfluencerCandidatesOrderBy = {
  createdAt?: Sort | null;
};
export type CampaignApplyHistoryQuery$variables = {
  after?: string | null;
  first?: number | null;
  influencerId: string;
  orderBy?: InfluencerCandidatesOrderBy | null;
};
export type CampaignApplyHistoryQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CampaignApplyHistoryPagination">;
};
export type CampaignApplyHistoryQuery = {
  response: CampaignApplyHistoryQuery$data;
  variables: CampaignApplyHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "influencerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orderBy"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "influencerId",
    "variableName": "influencerId"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignApplyHistoryQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "CampaignApplyHistoryPagination"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignApplyHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CandidateConnection",
        "kind": "LinkedField",
        "name": "candidates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CandidateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Candidate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "price",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customPrice",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Post",
                    "kind": "LinkedField",
                    "name": "post",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "finishedAt",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Campaign",
                    "kind": "LinkedField",
                    "name": "campaign",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parentMediaType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Banner",
                        "kind": "LinkedField",
                        "name": "banners",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "file",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "influencerId",
          "orderBy"
        ],
        "handle": "connection",
        "key": "CampaignApplyHistory_candidates",
        "kind": "LinkedHandle",
        "name": "candidates"
      }
    ]
  },
  "params": {
    "cacheID": "93785c41cdec444c708540b549a8c35c",
    "id": null,
    "metadata": {},
    "name": "CampaignApplyHistoryQuery",
    "operationKind": "query",
    "text": "query CampaignApplyHistoryQuery(\n  $after: String\n  $first: Int\n  $influencerId: ID!\n  $orderBy: InfluencerCandidatesOrderBy\n) {\n  ...CampaignApplyHistoryPagination_3VBRDd\n}\n\nfragment CampaignApplyHistoryPagination_3VBRDd on Query {\n  candidates(first: $first, after: $after, influencerId: $influencerId, orderBy: $orderBy) {\n    edges {\n      node {\n        id\n        createdAt\n        ...CampaignSmallCandidate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CampaignSmallCandidate on Candidate {\n  id\n  price\n  customPrice\n  status\n  post {\n    id\n    status\n    finishedAt\n  }\n  campaign {\n    id\n    title\n    parentMediaType\n    banners {\n      file\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "332ff8812102e673e7dcc8bc2bffa136";

export default node;
